<div *ngIf="((IsEditing$ | async) && (ApPermissions.EDIT_FIELDS | getPermission | async) === true)">
  <ap-new-field-toolbar></ap-new-field-toolbar>
</div>
